export const beforeSubmitTest = [
  {
    description: "Submit trc 5' va lam xong tat ca cac cau hoi",
    conditions: [
      {
        description: "Submit trc 5' va lam xong tat ca cau hoi",
        remainTimeInSecond: {
          greaterThan: 300,
        },
        remainQuestion: {
          equal: 0,
        },
        skill: {
          equal: 'READING',
        },
      },
    ],
    action: {
      showPopUp: {
        icon: 'info',
        title: 'Xem kỹ lại đáp án',
        message:
          'Bạn còn tận {{remainTimeInMinutes}} phút nữa đó, xem kỹ lại đáp án để câu hỏi cao hơn nha.',
        placeholder: ['remainTimeInMinutes'],
        confirm: {
          label: 'Nộp luôn',
          action: {
            setValue: {
              isSubmitAfterWarning: true,
              isAnswersAllQuestions: true,
              isChangedAfterDoubleCheck: {
                type: 'compare',
                fields: ['userAnswers', 'lastUserAnswers'],
                operation: 'notEqual',
              },
            },
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Xem lại',
          action: {
            setValue: {
              isSubmitAfterWarning: false,
              isAnswersAllQuestions: true,
              isDoubleCheck: true,
              lastUserAnswers: {
                type: 'assign',
                from: 'userAnswers',
              },
            },
          },
        },
      },
    },
  },
  {
    description: 'Submit trước 5 phút và chưa xong hết tất cả các câu hỏi',
    conditions: [
      {
        description: 'Submit trước 5 phút và chưa xong hết tất cả các câu hỏi',
        remainTimeInSecond: {
          greaterThan: 300,
        },
        remainQuestion: {
          greaterThan: 0,
        },
        skill: {
          equal: 'READING',
        },
      },
    ],
    action: {
      showPopUp: {
        icon: 'warning',
        title: 'Thiếu câu',
        // TODO support regex to get variable name
        message: 'Bạn còn thiếu {{remainQuestion}} câu chưa làm kìa',
        placeholder: ['remainQuestion'],
        confirm: {
          label: 'Nộp bất chấp',
          action: {
            setValue: {
              isSubmitAfterWarning: true,
              isSubmitAnyway: true,
            },
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Xem lại',
          action: {
            setValue: {
              isSubmitAfterWarning: false,
              isDoubleCheck: true,
            },
          },
        },
      },
      setValue: {
        isClickSubmitWithinRemainTimeAndQuestion: true,
        isAnswersAllQuestions: false,
      },
    },
  },
  {
    description: "Submit trong 5' còn lại và chưa làm xong",
    conditions: [
      {
        description: "Submit trong 5' còn lại và chưa làm xong",
        remainTimeInSecond: {
          greaterThan: 0,
          lessThanEqual: 300,
        },
        remainQuestion: {
          greaterThan: 0,
        },
        skill: {
          equal: 'READING',
        },
      },
    ],
    action: {
      setValue: {
        isClickSubmitOnTimeWithinRemainQuestion: true,
        isAnswersAllQuestions: false,
      },
      showPopUp: {
        icon: 'warning',
        title: 'Thiếu câu',
        // TODO support regex to get variable name
        message: 'Mình vẫn còn {{remainQuestion}} câu chưa làm.',
        placeholder: ['remainQuestion'],
        confirm: {
          label: 'Nộp luôn',
          action: {
            setValue: {
              isSubmitOnTime: true,
            },
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Làm tiếp',
          action: {
            setValue: {
              isDoubleCheck: true,
            },
          },
        },
      },
    },
  },
  {
    description: "Submit trong 5' còn lại",
    conditions: [
      {
        description: "Submit trong 5' còn lại ",
        remainTimeInSecond: {
          greaterThan: 0,
          lessThanEqual: 300,
        },
        remainQuestion: {
          equal: 0,
        },
        skill: {
          equal: 'READING',
        },
      },
    ],
    action: {
      setValue: {
        isSubmitOnTime: true,
        isAnswersAllQuestions: true,
      },
      submitTest: {},
      showPopUp: {
        type: 'success',
        icon: 'success',
        message:
          'Chúc mừng bạn đã hoàn thành xong bài đúng hạn. Cùng nhau xem kết quả và đáp án nhé.',
        confirm: {
          label: 'Xem đáp án',
          action: {
            routeTo: {},
          },
        },
      },
    },
  },
  {
    description: 'Time up and auto submit',
    conditions: [
      {
        description: 'Time up and auto submit conditions',
        remainTimeInSecond: {
          lessThanEqual: 0,
        },
        skill: {
          equal: 'READING',
        },
      },
    ],
    action: {
      setValue: {
        isSubmitOnTime: true,
      },
      submitTest: {},
      routeTo: {},
    },
  },
  {
    description: 'listening - submit in review time and answers all questions',
    conditions: [
      {
        description: 'listening - submit in review time and answers all questions',
        reviewing: {
          equal: true,
        },
        remainQuestion: {
          equal: 0,
        },
        skill: {
          equal: 'LISTENING',
        },
      },
    ],
    action: {
      submitTest: {},
      routeTo: {},
    },
  },
  {
    description: 'listening - submit in review time and do not answer all questions',
    conditions: [
      {
        description: 'listening - submit in review time and do not answer all questions',
        reviewing: {
          equal: true,
        },
        remainQuestion: {
          greaterThan: 0,
        },
        skill: {
          equal: 'LISTENING',
        },
      },
    ],
    action: {
      showPopUp: {
        icon: 'warning',
        title: 'Thiếu câu',
        message: 'Bạn vẫn còn {{remainQuestion}} câu chưa điền.',
        placeholder: ['remainQuestion'],
        confirm: {
          label: 'Nộp bất chấp',
          action: {
            submitTest: {},
            routeTo: {},
          },
        },
        cancel: {
          label: 'Quay lại',
          action: {},
        },
      },
    },
  },
];
